<div class="t-popup popup-graphs" style="display: block;height:100%;z-index: 990">

    <div class="popup-close"></div>

    <div class="popup-frame">
        <div class="popup-body">
            <h2>DICOM Inbox - Unassociated Studies</h2>
            <div class="graphs-container">
                <div class="l-flex l-flex-w t-fieldmargin patient-details" style="margin-top: -3em;">

                    <div class="l-flex l-flex-c t-field t-field-pad" style="width: 14em; margin-right: 2em;margin-left: calc(50vw - 36em);">
                        <label>From</label>
                        <i class="t-sep"></i>
                        <span class="t-validation-wrap l-fg1">
                            <input [(ngModel)]="From" (click)="frompicker.open()" (dateChange)="getList()" readonly [matDatepicker]="frompicker" class="t-field-text w100 t-field--date"/>
                            <mat-datepicker #frompicker [startAt]="startb"></mat-datepicker>
                        </span>
                    </div>

                    <div class="l-flex l-flex-c t-field t-field-pad" style="width: 14em">
                        <label>Until</label>
                        <i class="t-sep"></i>
                        <span class="t-validation-wrap l-fg1">
                            <input [(ngModel)]="To" (click)="topicker.open()" (dateChange)="getList()" readonly [matDatepicker]="topicker" class="t-field-text w100 t-field--date"/>
                            <mat-datepicker #topicker [startAt]="start"></mat-datepicker>
                        </span>
                    </div>

                </div>
                <main class="l-deashboard" style="margin-top: 1em;">

                    <div *ngIf="loading" class="dicom-inbox-status">Searching for unassociated studies…</div>
                    <div *ngIf="!loading && studies.length === 0" class="dicom-inbox-status">No unassociated studies found in this date range.</div>

                    <table *ngIf="!loading && studies.length > 0" class="dicom-inbox-table">
                        <thead>
                            <tr>
                                <th>Date</th>
                                <th>Patient Name</th>
                                <th>Patient ID</th>
                                <th>Accession</th>
                                <th>Modality</th>
                                <th>Images</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let study of studies">
                                <td>{{study.studyDate | date:'dd-MM-yyyy'}}</td>
                                <td>{{study.patientName}}</td>
                                <td>{{study.patientId}}</td>
                                <td>{{study.accessionNumber || '-'}}</td>
                                <td>{{study.modality}}</td>
                                <td>{{study.numInstances || ''}}</td>
                                <td class="dicom-inbox-actions">
                                    <button class="dicom-inbox-view-btn" (click)="view(study.studyUID)" title="Open this study in the Artisan DICOM Viewer to verify before linking">View</button>
                                    <button class="dicom-inbox-link-btn" (click)="link(study.studyUID)" title="Link this study to the current exam">Link</button>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                </main>
            </div>
            <button type="button" class="popup-close-button" (click)="closed.emit()">Close</button>
        </div>
    </div>
</div>
